var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"width":"20","height":"20","rx":"6","fill":"#0F172A","fill-opacity":"0.1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }